<template>
  <!-- Feedback Modal -->
  <modal id="feedback-modal" :close-text="'Cancel'" close-class="btn-default pull-left">
    <template slot="title"> Give Product Feedback</template>

    <template v-if="!isSent">
      <form id="feedback-form" slot="body">
        <div class="alert alert-warning text-center" role="alert">
          If you require assistance, please reach out to CapsimInbox support: support@capsim.com
        </div>
        <div class="form-group">
          <label for="type"
            >Please select your feedback category below:
            <span class="req-star">*</span>
          </label>
          <select class="form-control" id="type" v-model="feedbackForm.feedbackCategoryKey">
            <option
              v-for="{ category, feedbackCategoryKey } in feedbackTypes"
              :value="feedbackCategoryKey"
              :key="feedbackCategoryKey"
            >
              {{ category }}
            </option>
          </select>
          <template v-if="feedbackForm.feedbackCategoryKey === 0 && formNotFilled">
            <p class="error-msg">Please complete this required field.</p>
          </template>
        </div>
        <div class="form-group">
          <label for="feedback">Tell us what you think: <span class="req-star">*</span></label>
          <textarea class="form-control" v-model="feedbackForm.feedback"></textarea>
          <template v-if="feedbackForm.feedback === '' && formNotFilled">
            <p class="error-msg">Please complete this required field.</p>
          </template>
        </div>
      </form>
      <div slot="footer">
        <button @click.prevent="closeModal" class="btn btn-default pull-left">Cancel</button>
        <button @click.prevent="postFeedback" class="btn btn-primary">Send</button>
      </div>
    </template>
    <template v-else>
      <div slot="body" class="alert alert-success text-center" role="alert">
        Product feedback successfully sent!
      </div>
      <div slot="footer"></div>
    </template>
  </modal>
</template>
<script>
  import { getFeedbackArray, sendFeedback } from '@authoringPlatform/../api/feedback';
  export default {
    props: {
      isOpen: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        isSent: false,
        formNotFilled: false,
        feedbackTypes: [],
        feedbackForm: {
          feedbackCategoryKey: 0,
          feedback: '',
        },
      };
    },
    created() {
      this.getFeedbackTypes();
    },

    mounted() {
      if (this.isOpen) {
        $(`#feedback-modal`).modal('show');
      }
    },

    methods: {
      async getFeedbackTypes() {
        const feedbackArray = await getFeedbackArray();
        const getApplicableTypes = (f) => f.feedbackCategoryKey > 3;
        this.feedbackTypes = feedbackArray.filter((f) => getApplicableTypes(f));
      },

      async postFeedback() {
        if (this.isFormErrors()) {
          this.formNotFilled = true;
        } else {
          const category = this.feedbackTypes.find(
            (fc) => fc.feedbackCategoryKey === this.feedbackForm.feedbackCategoryKey
          ).category;
          let payload = {
            ...this.feedbackForm,
            category,
          };

          await sendFeedback(payload);
          this.isSent = true;
        }
      },

      isFormErrors() {
        return this.feedbackForm.feedbackCategoryKey === 0 || this.feedbackForm.feedback === '';
      },

      closeModal() {
        $('#feedback-modal').modal('hide');
      },
    },
  };
</script>
<style scoped>
  .req-star,
  .error-msg {
    color: red;
  }

  .error-msg {
    font-size: 12px;
  }
</style>
